import { configureStore } from "@reduxjs/toolkit";
import globalReducer from "./global";
import userReducer from "./user";
import channelReducer from "./channel";

const store = configureStore({
  reducer: {
    globalReducer,
    userReducer,
    channelReducer,
  },
});

export default store;
